<template>
    <div id="App">
        <progress-indicator/>
        <router-view/>
        <notifications/>
        <modal/>
        <confirm-popup/>
    </div>
</template>

<script>
    export default {
        name: 'App',

        components: {
            Notifications: () => import('@/components/controls/Notifications'),
            ProgressIndicator: () => import('@/components/controls/ProgressIndicator'),
            Modal: () => import('@/components/modals/Modal'),
            ConfirmPopup: () => import('@/components/popups/ConfirmPopup')
        }
    }
</script>

<style lang="scss" scoped>
    #App {
        font-family: 'Asap', sans-serif;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue